const orderSourceVariants = [
  { id: "EDI", name: "EDI" },
  { id: "batchjob", name: "Batch Job" }
];

export { orderSourceVariants };
